module.exports = __webpack_public_path__ + "media/images/category/dummy/bag01-d5e0f7be0e087f0a161cb26a1bd7ad28.jpg";